
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/attio",
      function () {
        return require("private-next-pages/destinations/attio.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/attio"])
      });
    }
  